module.exports = __webpack_public_path__ + "img/shuju.436b3ac0.png";